import React, { useContext } from "react";

import { Grid } from "@mui/material";
//@ts-ignore
import { StriimButton, StriimTypography } from "@striim/striim-ui";
import ConnectionProfileFieldsContext from "../create-edit-connection-profile/connection-profile-fields.context";
import StriimCircularProgress from "./circular-progress/circular-progress";
interface CpTestConnectionButtonProps {
    onTestClick: () => void;
}

const CpTestConnectionButton: React.FC<CpTestConnectionButtonProps> = ({ onTestClick }) => {
    const { isTestInProgress, isTestButtonEnabled, testConnectionResponse } = useContext(
        ConnectionProfileFieldsContext
    );
    const hasError = testConnectionResponse.length && testConnectionResponse.some(response => !response.result);
    const testCPProgress = isTestInProgress || !testConnectionResponse.length ? "" : !hasError ? "success" : "error";

    return (
        <Grid container item gap={1} ml={0}>
            <Grid item>
                <StriimButton
                    variant="secondary"
                    disabled={!isTestButtonEnabled}
                    onClick={onTestClick}
                    data-testid="test-connection-button"
                >
                    {!testConnectionResponse.length ? "Test" : "Retest"}
                </StriimButton>
            </Grid>
            {isTestInProgress || testConnectionResponse.length ? (
                <Grid item display={"flex"} alignItems={"center"} gap={1} data-test-id="test-status">
                    <StriimCircularProgress size={24} status={testCPProgress} />
                    {testCPProgress === "success" && <StriimTypography variant="h4">Test Success</StriimTypography>}
                    {testCPProgress === "error" && (
                        <StriimTypography variant="h4" data-test-id="sign-in-status">
                            Test Failed
                        </StriimTypography>
                    )}
                    {isTestInProgress && <StriimTypography variant="h4">Test in Progress</StriimTypography>}
                </Grid>
            ) : null}
        </Grid>
    );
};

export default CpTestConnectionButton;
